var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w_1200 m_lr_auto m_t_60"},[_c('div',{staticClass:"f_w_700 f_s_32 p_b_10"},[_vm._v("Update")])])
}]

export { render, staticRenderFns }